import React from 'react';
import PropTypes from 'prop-types';

import Button from 'shared/button';

export function ClearFilters({ onClick }) {
  return (
    <Button.Cancel
      className="responsive-filters-toggle me-2"
      label="Clear All"
      onClick={onClick}
    />
  );
}

ClearFilters.propTypes = {
  onClick: PropTypes.func
};

export default ClearFilters;
